<template>

  <section class="p-0">
    <div class="animation-circle-inverse">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="thanks-bg">
      <div class="thank-you">
        <img src="../assets/images/thanks.gif" alt="thanks" class="img-fluid" />
        <h3 class="mb-4">Thank you for Downloading the ChatLoop!</h3>
      </div>
    </div>
  </section>

</template>
<script>
export default {
  name: "Signin",
  mounted: function () {
    document.body.classList.remove("inner-page");
  },
};
</script>
